import React from 'react';
import { PermissionsEnum } from 'utils';
import { channelIsChecked, PermissionElementAttrEnum } from 'pages/administration.page';

export const ChannelsAccessPermissionView = ({ channel, policy, onChange }) => (
  <div className="channel-rights">
    <input
      type="checkbox"
      {...{
        [PermissionElementAttrEnum.PERMISSION_NAME]: PermissionsEnum.CHANNEL_ACCESS,
        [PermissionElementAttrEnum.POLICY_ID]: policy.id,
        [PermissionElementAttrEnum.POLICY_NAME]: policy.organizationGroup,
      }}
      value={channel.id}
      defaultChecked={channelIsChecked(policy, channel)}
      onChange={onChange}
    />
    <div className="admin-label">{channel.name}</div>
  </div>
);
